(function() {
    const $modalTriggers = document.querySelectorAll('[data-modal]')
    $modalTriggers.forEach(async $t => {
        const { ModalController }  = await import('./Modal')
        new ModalController.Modal($t)
    })
    const $modalInline = document.querySelectorAll('.modal-inline')
    $modalInline.forEach(async $mi => {
        const { ModalController }  = await import('./Modal')
        new ModalController.ModalInline($mi)
    })
})()